var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { style: { height: "100%" } },
    [
      _c(
        "w-col",
        {
          attrs: {
            xs: "12",
            sm: "12",
            md: "12",
            lg: "5",
            center: "",
            "no-margin": "",
          },
        },
        [
          _c("w-scroll-view", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "content-block" },
              [
                _c(
                  "transition",
                  { attrs: { name: "fast-fade", mode: "out-in" } },
                  [
                    _vm.currentPage == "loading"
                      ? [
                          _c("div", [
                            _c("h1", [_vm._v(_vm._s(_vm.$ct("title")))]),
                            _c("h2", [_vm._v(_vm._s(_vm.$ct("sub-title")))]),
                            _c(
                              "div",
                              { staticClass: "circle" },
                              [
                                _c("w-fa", {
                                  staticClass: "welcome-icon",
                                  attrs: { icon: "anchor" },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _vm.currentPage == "plan"
                      ? _c("the-choose-plan", {
                          attrs: { vertical: "" },
                          on: {
                            order: function ($event) {
                              return _vm.order()
                            },
                          },
                        })
                      : _vm.currentPage == "heading"
                      ? _c("app-heading-input", {
                          attrs: {
                            "controls-disabled": _vm.controlsDisabled,
                            content: _vm.content,
                          },
                          on: {
                            logout: function ($event) {
                              return _vm.logout()
                            },
                            next: function ($event) {
                              ;(_vm.currentPage = "logo"), (_vm.step = 3)
                            },
                          },
                        })
                      : _vm.currentPage == "logo"
                      ? _c("app-logo-upload", {
                          attrs: {
                            content: _vm.content,
                            "controls-disabled": _vm.controlsDisabled,
                          },
                          on: {
                            prev: function ($event) {
                              ;(_vm.currentPage = "heading"), (_vm.step = 2)
                            },
                            next: function ($event) {
                              ;(_vm.currentPage = "peppol"), (_vm.step = 4)
                            },
                            skip: function ($event) {
                              ;(_vm.currentPage = "peppol"), (_vm.step = 4)
                            },
                            switch: function ($event) {
                              return _vm.switchFade()
                            },
                          },
                        })
                      : _vm.currentPage == "peppol"
                      ? _c("app-peppol-setup", {
                          attrs: {
                            content: _vm.content,
                            "controls-disabled": _vm.controlsDisabled,
                          },
                          on: {
                            prev: function ($event) {
                              ;(_vm.currentPage = "logo"), (_vm.step = 3)
                            },
                            next: function ($event) {
                              return _vm.finish()
                            },
                            skip: function ($event) {
                              return _vm.finish()
                            },
                            disable: function ($event) {
                              _vm.controlsDisabled = true
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      !_vm.$wf.isSmDown
        ? _c("app-billboard", {
            attrs: { xs: "12", sm: "12", md: "12", lg: "7", step: _vm.step },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }